import { render } from "./SpecialRewardTemplates.vue?vue&type=template&id=06ac1270&scoped=true"
import script from "./SpecialRewardTemplates.vue?vue&type=script&lang=js"
export * from "./SpecialRewardTemplates.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-06ac1270"

export default script